import { createStructuredSelector } from "reselect";
import {
    DATA_QUALITY,
    DATA_QUALITY_SUCCESS,
    DATA_QUALITY_ERROR,
    DATA_QUALITY_MODAL_SET,
    DATA_QUALITY_DETAIL,
    DATA_QUALITY_DETAIL_SUCCESS,
    DATA_QUALITY_DETAIL_ERROR,
    DATA_QUALITY_SEARCH_SET,
    DATA_QUALITY_SEARCH_CHANGE,
    DATA_QUALITY_PAGE_SET

} from "../actions";

export const NAME = 'dataQuality';

export const DataQuality = (page, num_page, orderBy, filters, stateFilter) => ({
    type: DATA_QUALITY,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DataQualitySuccess = (data) => ({
    type: DATA_QUALITY_SUCCESS,
    payload: data
});

export const DataQualityError = (error) => ({
    type: DATA_QUALITY_ERROR,
    payload: error
});

export const DataQualityModalSet = (data) => ({
    type: DATA_QUALITY_MODAL_SET,
    payload: data
});

export const DataQualityDetail = (data) => ({
    type: DATA_QUALITY_DETAIL,
    payload: data
});

export const DataQualityDetailSuccess = (data) => ({
    type: DATA_QUALITY_DETAIL_SUCCESS,
    payload: data
});

export const DataQualityDetailError = (error) => ({
    type: DATA_QUALITY_DETAIL_ERROR,
    payload: error
});

export const DataQualitySearchSet = (data) => ({
    type: DATA_QUALITY_SEARCH_SET,
    payload: data
});

export const DataQualitySearchChangeSet = (data) => ({
    type: DATA_QUALITY_SEARCH_CHANGE,
    payload: data
});

export const DataQualityPageSet = (data) => ({
    type: DATA_QUALITY_PAGE_SET,
    payload: data
});

const dataQuality = (state) => state[NAME];

export const DataQualitySelector = createStructuredSelector({
    dataQuality
})